'use client';

import type { ReactNode } from 'react';
import { notFound } from 'next/navigation';

export default function EmbedLayout({ children }: { children: ReactNode }) {
  if (process.env.NEXT_PUBLIC_TOUR_BUILD !== 'true') {
    notFound();
  }
  return children;
}
